import Icon from "../selfcare/Icon.tsx";
import PhoneNumberSpanComponent from "./PhoneNumberSpanComponent.tsx";
import {useEffect, useState} from "react";
import CallMeFormComponent from "./CallMeFormComponent.tsx";
import LoaderSpinner from "../loaders/LoaderSpinner.tsx";
import {CallMeNumberVariantA, CallMeState, ContactDetails, getDetails} from "../../util/callMe.ts";
import IconPhone from "../icons/IconPhone.tsx";

export default function CallMeRTOComponent(props: { className?: string }) {
    const [details, setDetails] = useState<{ details: ContactDetails, state: CallMeState }>()
    const [error, setError] = useState<boolean>(false)

    useEffect(() => {
        getDetails(CallMeNumberVariantA)
            .then((d) => setDetails(d))
            .catch(() => setError(true))
    }, [])

    if (error) {
        return
    }

    if (details === undefined) {
        return (
            <section className={`call-me rto ${props.className}`}>
                <LoaderSpinner/>
            </section>
        )
    }

    return (
        <section className={`call-me rto open ${props.className}`}>
            <div className="content">
                <h2 className="heading heading--montserrat">
                    {details.state === CallMeState.InboundOpen && (
                        <>
                            <span className="hide-on-small-devices">Brug for hjælp til bestilling af internet?</span>
                            <span className="hide-on-large-devices">Ring for et godt tilbud på bredbånd</span>
                        </>
                    )}
                    {details.state !== CallMeState.InboundOpen && (
                        <>
                            <span className="hide-on-small-devices">Brug for hjælp til bestilling af internet?</span>
                            <span className="hide-on-large-devices">Brug for et godt tilbud på bredbånd?</span>
                        </>
                    )}
                </h2>

                {details.state === CallMeState.OutboundOpen && (
                    <p>Vi ringer inden for en time</p>
                )}

                {details.state === CallMeState.InboundAndOutboundClosed && (
                    <p>Vi ringer hurtigst muligt</p>
                )}

                {details.state === CallMeState.InboundOpen && (
                    <>
                        <a className="call-button hide-on-small-devices" href={`tel:+45${details.details.phone_no_primary}`}>
                            <span><PhoneNumberSpanComponent phoneNo={details.details.phone_no_primary}/></span>
                            <Icon component={IconPhone}/>
                        </a>
                        <a className="call-button hide-on-large-devices" href={`tel:+45${details.details.phone_no_primary}`}>
                            <span><PhoneNumberSpanComponent phoneNo={details.details.phone_no_primary}/></span>
                            <Icon component={IconPhone}/>
                        </a>
                        <p>
                            Vi kan hjælpe dig i gang med lynhurtigt internet på 5 min.
                        </p>
                    </>
                )}

                {details.state !== CallMeState.InboundOpen && (
                    <CallMeFormComponent/>
                )}
            </div>
        </section>
    )
}
